import { useSyncExternalStore } from 'react';

/** Keep in sync with the comment at the top of styles/tokens.css. */
export const BREAKPOINTS = { tablet: 768, desktop: 1200 } as const;

export type LayoutMode = 'phone' | 'tablet' | 'desktop';

function currentMode(): LayoutMode {
  if (typeof window === 'undefined') return 'desktop';
  if (window.matchMedia(`(min-width: ${BREAKPOINTS.desktop}px)`).matches) return 'desktop';
  if (window.matchMedia(`(min-width: ${BREAKPOINTS.tablet}px)`).matches) return 'tablet';
  return 'phone';
}

function subscribe(onChange: () => void): () => void {
  const queries = [BREAKPOINTS.tablet, BREAKPOINTS.desktop].map((px) => window.matchMedia(`(min-width: ${px}px)`));
  queries.forEach((q) => q.addEventListener('change', onChange));
  return () => queries.forEach((q) => q.removeEventListener('change', onChange));
}

export function useLayoutMode(): LayoutMode {
  return useSyncExternalStore(subscribe, currentMode, () => 'desktop');
}
